/**
 * @description way：客製化金牌製作加工方法
 */

import wayAImage from "@/images/way/way_a.jpg";
import wayBImage from "@/images/way/way_b.jpg";
import wayCImage from "@/images/way/way_c.jpg";
import wayDImage from "@/images/way/way_d.jpg";
import wayEImage from "@/images/way/way_e.jpg";
import wayFImage from "@/images/way/way_f.png";
import wayGForAFImage from "@/images/way/way_g_af.png";
import wayGForAGImage from "@/images/way/way_g_ag.png";
import wayHImage from "@/images/way/way_h.png";
import wayIImage from "@/images/way/way_i.png";
import wayJForAWImage from "@/images/way/way_j_aw.png";
import wayJForAXImage from "@/images/way/way_j_ax.png";
import wayKImage from "@/images/way/way_k.png";
import wayLImage from "@/images/way/way_l.png";

export default [
  {
    wayCode: "A",
    wayName: "精緻平裝純金金牌",
    image: { default: wayAImage },
  },
  {
    wayCode: "B",
    wayName: "立體浮雕純金金牌",
    image: { default: wayBImage },
  },
  {
    wayCode: "C",
    wayName: "立體浮雕鐳射紅字純金金牌",
    image: { default: wayCImage },
  },
  { wayCode: "D", wayName: "週歲鎖片", image: { default: wayDImage } },
  {
    wayCode: "E",
    wayName: "立體浮雕純金獎牌",
    image: { default: wayEImage },
  },
  {
    wayCode: "F",
    wayName: "手工精雕雙面扇",
    image: { default: wayFImage },
  },
  {
    wayCode: "G",
    wayName: "手工紋飾單面扇",
    image: { af: wayGForAFImage, ag: wayGForAGImage },
  },
  {
    wayCode: "H",
    wayName: "傳統金牌雷雕字體",
    image: { default: wayHImage },
  },
  {
    wayCode: "I",
    wayName: "立體浮雕純金鑰匙環",
    image: {
      default: wayIImage,
    },
  },
  {
    wayCode: "J",
    wayName: "立體浮雕純金獎牌",
    image: {
      aw: wayJForAWImage,
      ax: wayJForAXImage,
    },
  },
  {
    wayCode: "K",
    wayName: "關聖帝君法器",
    image: {
      default: wayKImage,
    },
  },
  {
    wayCode: "L",
    wayName: "中潭元帥法器",
    image: {
      default: wayLImage,
    },
  },
];
